import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bell" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "topbar-badge"
}
const _hoisted_3 = { class: "notifications-menu fade-in-up" }
const _hoisted_4 = { class: "notification-item" }
const _hoisted_5 = { class: "notification-summary" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  role: "menuitem"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-comment" }, null, -1)
const _hoisted_9 = { class: "notification-item" }
const _hoisted_10 = { class: "notification-detail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["notifications-item", { 'active-menuitem ': _ctx.topbarNotificationMenuActive }])
  }, [
    _createElementVNode("a", {
      href: "#",
      tabindex: "0",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onTopbarNotificationMenuButtonClick && _ctx.onTopbarNotificationMenuButtonClick(...args)))
    }, [
      _hoisted_1,
      (_ctx.notifications.length > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.notifications.length), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationModules, (notificationModule) => {
        return (_openBlock(), _createElementBlock("li", {
          key: notificationModule.groupId,
          role: "menuitem"
        }, [
          (_ctx.notifications.filter((notification) => notification.groupId === notificationModule.groupId).length > 0)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: `/notifications/${notificationModule.groupId}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass(`pi pi-${notificationModule.icon}`)
                  }, null, 2),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t(notificationModule.groupLabel)), 1),
                    _createElementVNode("div", {
                      class: "notification-detail",
                      innerHTML: _ctx.t('notification.alert', _ctx.notifications.filter((notification) => notification.groupId === notificationModule.groupId).length)
                    }, null, 8, _hoisted_6)
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (_ctx.notifications.length <= 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
            _createVNode(_component_router_link, { to: "/notifications" }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t("notification.none")), 1)
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}